<template>
	<v-sheet class="inventory" style="height: calc(100vh - 88px)">
		<template v-if="contentLoaded">
			<v-layout class="align-center light-blue-bg px-4 py-2">
				<v-flex md12>
					<v-layout class="justify-content-between align-items-center">
						<v-flex class="d-flex align-items-center flex-wrap">
							<p class="my-auto font-level-3-bold" style="font-size: 20px">
								<ShowValue :object="product" object-key="name" label="Product Name"></ShowValue>
							</p>
							<ShowBarcode
								:object="product"
								object-key="barcode"
								tooltip
								tooltip-text="product #"
								click-to-copy
								label="barcode"
							></ShowBarcode>
							<!--  <div v-if="product && product.requestpobarcode && product.requestpobarcode.barcode" class="m-2">
								<v-chip label color="red" outlined>
									<span class="fw-500">{{product.request_po_data.barcode}}</span>
								</v-chip>
							</div> -->

							<div
								v-if="product && product.requestpobarcode && product.requestpobarcode.barcode"
								class="m-2"
							>
								<v-chip label color="green" outlined>
									<span class="fw-500" v-on:click="RequestPoDetail(product.requestpobarcode.uuid)">{{
										product.requestpobarcode.barcode
									}}</span>
								</v-chip>
							</div>

							<!-- <div class="m-2">
								<v-chip
									v-if="product.status_value"
									label
									:color="`${getStatusColor(product.status_value)} white--text text-capitilize`"
									class="mr-2"
								>
									{{ product.status_value }}
								</v-chip>
							</div> -->
						</v-flex>

						<v-flex md7 class="text-right">
							<template v-if="false && inventory.retired">
								<v-btn
									v-on:click="doAction('stock-history')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-history</v-icon>Stock History</v-btn
								>
								<v-btn
									v-on:click="doAction('print-label')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-printer</v-icon>Print Label</v-btn
								>
							</template>
							<template v-else>
								<v-btn
									v-if="false && product.status == 3"
									color="green darken-4 text-white"
									class="ml-2"
									depressed
									tile
									v-on:click="doAction('activestatus')"
								>
									<v-icon small left>mdi-pencil</v-icon>Approve
								</v-btn>

								<v-btn
									color="blue darken-4 text-white"
									class="ml-2"
									depressed
									tile
									v-on:click="doAction('edit')"
									v-if="product.status != 3"
								>
									<v-icon small left>mdi-pencil</v-icon>Edit
								</v-btn>
								<v-btn
									v-on:click="backToListing('product')"
									color="grey lighten-3"
									class="ml-2"
									depressed
									tile
									><v-icon small left>mdi-arrow-left</v-icon>Back</v-btn
								>
								<v-menu v-if="false" offset-y left bottom content-class="elevation-3" rounded="0">
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											color="blue darken-4 text-white"
											v-on="on"
											v-bind="attrs"
											class="mr-2"
											depressed
											tile
											><v-icon small left>mdi-more mdi-flip-h</v-icon>More</v-btn
										>
									</template>
									<v-list>
										<v-list-item v-if="false" v-on:click="doAction('stock-history')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-history</v-icon>
												Stock History</v-list-item-title
											>
										</v-list-item>
										<v-list-item v-if="false" v-on:click="doAction('print-label')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-printer</v-icon>
												Print Label</v-list-item-title
											>
										</v-list-item>
										<v-list-item
											v-if="inventory.retired == 0 && getPermission('inventory:update')"
											v-on:click="doAction('edit')"
										>
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-pencil</v-icon>
												Edit
											</v-list-item-title>
										</v-list-item>
										<v-list-item v-if="getPermission('inventory:create')" v-on:click="doAction('duplicate')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-content-duplicate</v-icon>
												Clone
											</v-list-item-title>
										</v-list-item>
										<v-list-item v-if="getPermission('inventory:delete')" v-on:click="doAction('delete')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-delete</v-icon>
												Delete
											</v-list-item-title>
										</v-list-item>
										<!-- Used In responsive -->
										<template v-if="deviceWidth < 1360.98">
											<template v-if="!inventory.retired && inventory.initial_stock > 0">
												<v-list-item v-if="getPermission('checkout:create')" v-on:click="doAction('checkout')">
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-share-outline</v-icon>
														Issue
													</v-list-item-title>
												</v-list-item>
												<v-list-item
													v-if="getPermission('inventory:update')"
													v-on:click="doAction('retire-stock')"
												>
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-cancel</v-icon>
														Retire Stock
													</v-list-item-title>
												</v-list-item>
												<v-list-item v-if="getPermission('inventory:update')" v-on:click="doAction('retire')">
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-cancel</v-icon>
														Retire
													</v-list-item-title>
												</v-list-item>
											</template>
										</template>
									</v-list>
								</v-menu>
								<template v-if="false && deviceWidth > 1360.02">
									<template v-if="!inventory.retired && inventory.initial_stock > 0">
										<v-btn
											v-if="getPermission('checkout:create')"
											v-on:click="doAction('checkout')"
											color="blue darken-4 text-white"
											class="mx-2"
											depressed
											tile
										>
											<v-icon small left>mdi-share-outline</v-icon>Issue
										</v-btn>
										<v-btn
											v-if="getPermission('inventory:update')"
											v-on:click="doAction('retire-stock')"
											color="blue darken-4 text-white"
											class="ml-2"
											depressed
											tile
											><v-icon small left>mdi-cancel</v-icon>Retire Stock</v-btn
										>
										<v-btn
											v-if="getPermission('inventory:update')"
											v-on:click="doAction('retire')"
											color="blue darken-4 text-white"
											class="ml-2"
											depressed
											tile
											><v-icon small left>mdi-cancel</v-icon>Retire</v-btn
										>
									</template>
									<v-btn
										v-if="false"
										v-on:click="doAction('reserve')"
										color="blue darken-4 text-white"
										class="ml-2"
										depressed
										tile
										><v-icon small left>mdi-calendar-check</v-icon>Reserve</v-btn
									>
								</template>
								<v-btn
									v-if="inventory.retired == 0 && getPermission('inventory:update')"
									v-on:click="doAction('add-stock')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-playlist-plus</v-icon>Add Stock</v-btn
								>
							</template>
						</v-flex>
					</v-layout>
					<div class="d-flex mt-4">
						<div class="w-10 pr-3">
							<ImageTemplate circle :src="product.image"></ImageTemplate>
						</div>
						<div class="w-100 pr-3">
							<div
								v-if="false && inventory.pico_barcode && inventory.barcode_image"
								style="max-width: 300px"
							>
								<div class="d-inline-block text-center">
									<img
										style="max-width: 100%; height: 30px"
										:src="inventory.barcode_image"
										:alt="inventory.pico_barcode"
									/>
									<pre class="mb-0 barcode-text bold-700">{{ inventory.pico_barcode }}</pre>
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="width-66 d-flex flex-wrap">
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600">Serial Number : </span>
											<span class="fw-500 no-wrap">
												<v-chip
													label
													color="blue lighten-4 blue--text text--darken-4"
													v-if="false && product.serial_number"
												>
													{{ product.serial_number }}
												</v-chip>
												<ShowValue
													:object="product"
													object-key="serial_number"
													label="Serial Number"
												></ShowValue>
											</span>
										</div>
									</div>
									<!-- <div class="width-50">
										<div class="mt-2">
											<span class="fw-600"> Product Type : </span>
											<v-chip
												label
												color="blue lighten-4 blue--text text--darken-4 text-capitilize"
												v-if="false && product.type"
											>
												{{ product.type }}
											</v-chip>
											<ShowValue :object="product" object-key="type" label="type"></ShowValue>
										</div>
									</div> -->
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600"> Category : </span>
											<v-chip
												label
												color="blue lighten-4 blue--text text--darken-4"
												v-if="false && product.category"
											>
												{{ product.category }}
											</v-chip>
											<ShowValue :object="product" object-key="category" label="category"></ShowValue>
										</div>
									</div>
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600">Reorder level : </span>
											<span class="fw-500 no-wrap">
												<ShowValue :object="product" object-key="reorder_level" label="Reorder Level">
												</ShowValue>
											</span>
										</div>
									</div>
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600"> Selling Price/Unit Price : </span>
											<span class="fw-500 no-wrap">
												<ShowPrice
													:object="product"
													object-key="selling_cost"
													label="selling price/unit price"
												></ShowPrice>
											</span>
										</div>
									</div>
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600"> Effective From : </span>
											<span class="fw-500 no-wrap">
												<span class="fw-500" v-if="product.effective_from">
													{{ formatDate(product.effective_from) }}
												</span>
												<em v-else class="text-muted">effective from</em>
											</span>
										</div>
									</div>
									<!-- <div class="width-50">
										<div class="mt-2">
											<span class="fw-600">Unit Price : </span>
											<span class="fw-500 no-wrap">
												<ShowPrice :object="product" object-key="unit_price" label="unit price"></ShowPrice>
											</span>
										</div>
									</div> -->
									<div class="width-50">
										<div class="mt-2">
											<span class="fw-600"> Discounted price : </span>
											<span class="fw-500 no-wrap">
												<ShowPrice
													:object="product"
													object-key="discount_price"
													label="discount price"
												></ShowPrice>
											</span>
										</div>
									</div>
								</div>
								<div class="width-33">
									<div class="width-100">
										<div class="mt-2">
											<span class="fw-600 mr-2">Created date : </span>
											<span class="fw-500" v-if="product.added_at">
												{{ formatDateTime(product.added_at) }}
											</span>
											<em v-else class="text-muted">no created date</em>
										</div>
									</div>
									<div class="width-100">
										<div class="mt-2">
											<span class="fw-600 mr-2">Created By : </span>
											<span class="fw-500">
												<ShowValue :object="product" object-key="added_by" label="created by"></ShowValue>
											</span>
										</div>
									</div>
									<div class="width-100">
										<div class="mt-2">
											<span class="fw-600 mr-2">Updated date : </span>
											<span class="fw-500" v-if="product.updated_at">
												{{ formatDateTime(product.updated_at) }}
											</span>
											<em v-else class="text-muted">no updated date</em>
										</div>
									</div>
									<div class="width-100">
										<div class="mt-2">
											<span class="fw-600 mr-2">Updated By : </span>
											<span class="fw-500">
												<ShowValue :object="product" object-key="updated_by" label="updated by"></ShowValue>
											</span>
										</div>
									</div>
								</div>
								<div class="width-100 d-flex flex-wrap">
									<div class="width-33" v-if="false">
										<div class="mt-2">
											<span class="fw-600 mr-2">Initial Stock : </span>
											<span class="fw-500 no-wrap">
												<v-badge color="blue" :content="`${product.initial_stock ? product.initial_stock : 0}`">
												</v-badge>
												<!-- {{ product.initial_stock ? product.initial_stock : 0 }} -->
											</span>
										</div>
									</div>
									<div class="width-33">
										<div class="mt-2">
											<span class="fw-600 mr-2">Available Stock : </span>
											<span class="fw-500 no-wrap text-h5">
												<v-badge
													color="green"
													:content="`${product.available_stock ? product.available_stock : 0}`"
												>
												</v-badge>
												<!-- <ShowValue :object="product" object-key="available_stock" label="available stock"></ShowValue> -->
											</span>
										</div>
									</div>
									<div class="width-33">
										<div class="mt-2">
											<span class="fw-600">Unit : </span>
											<span class="fw-500 no-wrap">
												<ShowValue :object="product" object-key="unit" label="unit"> </ShowValue>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-20 pr-3" v-if="false && inventory.unit">
							<div class="mt-2">
								<span class="fw-600">Pico Barcode : </span>
								<span class="fw-500">
									<Barcode circle :src="inventory.unit"></Barcode>
								</span>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<div>
				<v-tabs
					v-model="inventoryTab"
					background-color="transparent"
					color="blue"
					class="custom-tab-transparent"
					active-class="blue darken-4 text-white"
					hide-slider
				>
					<v-tab href="#detail">
						<v-icon small left>mdi-format-list-bulleted-square</v-icon> Details</v-tab
					>
					<v-tab href="#suppliers">
						<v-icon small left>mdi-account-group</v-icon> Suppliers ({{
							product.supplier_relation ? product.supplier_relation.length : 0
						}})</v-tab
					>
					<v-tab href="#pricing">
						<v-icon small left>mdi-currency-usd-circle-outline</v-icon> price ({{
							product.pricing_logs ? product.pricing_logs.length : 0
						}})</v-tab
					>
					<v-tab href="#quotation">
						<v-icon small left>mdi-receipt</v-icon> Quotation History ({{
							quotationListing?.tbody ? quotationListing?.tbody.length : 0
						}})
					</v-tab>
					<!-- <v-icon small left>mdi-receipt</v-icon> Quotation History
					</v-tab> -->

					<v-tab href="#purchase-order-moment-history">
						<v-icon small left>mdi-receipt</v-icon> Purchase Order Moment History
					</v-tab>
					<v-tab href="#event"> <v-icon small left>mdi-history</v-icon> Logs</v-tab>
					<v-tab href="#quantity-by-location" v-if="false">
						<v-icon small left>mdi-map-marker-outline</v-icon> Quantity by Location</v-tab
					>
					<v-tab v-if="false && getPermission('transaction:view')" href="#transaction">
						<v-icon small left>mdi-share-outline</v-icon> Transaction
					</v-tab>
					<v-tab v-if="false" href="#reservation">
						<v-icon small left>mdi-calendar-check</v-icon> Reservations</v-tab
					>
					<v-tab v-if="false" href="#retire_stock_records">
						<v-icon small left>mdi-calendar-check</v-icon> Retire Stock Records</v-tab
					>
					<v-tab href="#related-service" v-if="false">
						<v-icon small left>mdi-hammer-wrench</v-icon> Related Services</v-tab
					>
					<v-tab v-if="false" href="#work-order">
						<v-icon small left>mdi-clipboard-list</v-icon> Work Orders</v-tab
					>
					<v-tab v-if="false" href="#file">
						<v-icon small left>mdi-file-document-multiple</v-icon> Files</v-tab
					>
					<v-tab v-if="false" href="#comment">
						<v-icon small left>mdi-comment-multiple</v-icon> Comments</v-tab
					>
					<v-tab v-if="false" href="#support">
						<v-icon small left>mdi-page-next-outline</v-icon> Support</v-tab
					>
				</v-tabs>
				<v-tabs-items v-model="inventoryTab">
					<v-tab-item value="detail">
						<div class="mx-4">
							<div class="overflow-y" style="max-height: calc(100vh - 250px)">
								<v-layout class="p-4 border-bottom-light-grey min-height-57px">
									<v-flex class="font-level-3-bold my-auto">
										<span class="detail-svg-icon mr-2">
											<!--begin::Svg Icon-->
											<inline-svg :src="$assetURL('media/custom-svg/inventory-color.svg')" />
											<!--end::Svg Icon-->
										</span>
										Product Details
									</v-flex>
								</v-layout>
								<table width="100%" class="detail-table scattered-table">
									<tr>
										<th width="300px">Quote ref no.</th>
										<td width="30%">
											<ShowValue :object="product" object-key="quote_ref_no" label="quote ref no."></ShowValue>
										</td>
										<th width="300px">Material Standard</th>
										<td>
											<ShowValue
												:object="product"
												object-key="material_standard"
												label="Material Standard"
											></ShowValue>
										</td>
									</tr>
									<tr>
										<th>Manufacturer</th>
										<td>
											<ShowValue :object="product" object-key="manufacturer" label="Manufacturer"></ShowValue>
										</td>
										<th>Length</th>
										<td>
											<ShowValue :object="product" object-key="length" label="length"></ShowValue>
											<template v-if="product && product.length_unit"> {{ product.length_unit }} </template>
										</td>
									</tr>
									<tr>
										<th width="300px">Dimension Standard</th>
										<td>
											<ShowValue
												:object="product"
												object-key="dimension_standard"
												label="Dimension Standard"
											></ShowValue>
											<TooltipQuestion v-if="false">
												<template v-slot:text
													>For all locations without specified<br />thresholds, you will receive an<br />email
													alert when stock<br />quantity is higher than this value</template
												>
											</TooltipQuestion>
										</td>
										<template v-if="product.type == 'piping'">
											<th>Reduced diameter</th>
											<td>
												<ShowValue
													:object="product"
													object-key="reduced_diameter"
													label="reduced diameter"
												></ShowValue>
												<template v-if="product && product.reduced_diameter_unit">
													{{ product.reduced_diameter_unit }}
												</template>
											</td>
										</template>
										<template v-else>
											<th>Height</th>
											<td>
												<ShowValue :object="product" object-key="height" label="height"></ShowValue>
												<template v-if="product && product.height_unit"> {{ product.height_unit }} </template>
											</td>
										</template>
									</tr>
									<tr>
										<th>Unit Price Currency</th>
										<td>
											<ShowValue
												:object="product"
												object-key="unit_price_currency"
												label="unit price currency"
											></ShowValue>
										</td>
										<template v-if="product.type == 'piping'">
											<th>Diameter</th>
											<td>
												<ShowValue :object="product" object-key="diameter" label="diameter"></ShowValue>
												<template v-if="product && product.diameter_unit">
													{{ product.diameter_unit }}
												</template>
											</td>
										</template>
										<template v-else>
											<th>Width</th>
											<td>
												<ShowValue :object="product" object-key="width" label="width"></ShowValue>
												<template v-if="product && product.width_unit"> {{ product.width_unit }} </template>
											</td>
										</template>
									</tr>

									<tr>
										<th>Weight</th>
										<td>
											<ShowValue :object="product" object-key="weight" label="weight"></ShowValue>
											<template v-if="product && product.weight_unit"> {{ product.weight_unit }} </template>
										</td>
										<th>Width</th>
										<td>
											<ShowValue :object="product" object-key="width" label="width"></ShowValue>
											<template v-if="product && product.width_unit"> {{ product.width_unit }} </template>
										</td>
									</tr>
									<tr>
										<th>Height</th>
										<td>
											<ShowValue :object="product" object-key="height" label="height"></ShowValue>
											<template v-if="product && product.height_unit"> {{ product.height_unit }} </template>
										</td>
									</tr>
									<tr>
										<th width="300px" valign="top" class="pt-2">Description</th>
										<td colspan="3" class="break-spaces pt-2">
											<ShowValue :object="product" object-key="description" label="description"></ShowValue>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</v-tab-item>
					<v-tab-item value="suppliers">
						<SupplierListing
							v-if="inventoryTab == 'suppliers' && uuid"
							class="mx-4"
							type="inventory"
							:type-uuid="uuid"
						></SupplierListing>
					</v-tab-item>
					<v-tab-item value="pricing">
						<ProductPriceListing
							v-if="inventoryTab == 'pricing'"
							class="mx-4"
							type="inventory"
							:type-uuid="uuid"
							:price-data="product.pricing_logs"
							:product-status="product.status"
							v-on:success="getInventory()"
						></ProductPriceListing>
					</v-tab-item>
					<v-tab-item value="quotation">
						<ProductQuotationListing
							class="mx-4"
							v-if="inventoryTab == 'quotation' && uuid"
							:quotationListing="quotationListing"
							@update-product="(page) => getProductQuotation(uuid, page)"
						>
						</ProductQuotationListing>
					</v-tab-item>
					<v-tab-item value="purchase-order-moment-history">
						<ProductPOMomentHistory
							class="mx-4"
							v-if="inventoryTab == 'purchase-order-moment-history' && uuid"
						>
						</ProductPOMomentHistory>
					</v-tab-item>
					<v-tab-item value="event">
						<EventListing
							v-if="inventoryTab == 'event' && uuid"
							class="mx-4"
							type-text="Product"
							type="product"
							:type-uuid="uuid"
						></EventListing>
					</v-tab-item>
					<v-tab-item value="retire_stock_records" v-if="false">
						<ItemRetirementsListing
							v-if="inventoryTab == 'retire_stock_records'"
							class="mx-4"
							type-text="Inventory"
							type="inventory"
							:uuid="uuid"
						></ItemRetirementsListing>
					</v-tab-item>
					<v-tab-item value="quantity-by-location" v-if="false">
						<QuantityLocation
							v-if="inventoryTab == 'quantity-by-location'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></QuantityLocation>
					</v-tab-item>
					<v-tab-item value="transaction" v-if="false">
						<template v-if="inventoryTab == 'transaction'">
							<TransactionListing
								relation-type="inventory"
								:relation-type-id="inventory.id"
							></TransactionListing>
						</template>
					</v-tab-item>
					<v-tab-item value="reservation" v-if="false">
						<ReservationListing
							v-if="inventoryTab == 'reservation'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></ReservationListing>
					</v-tab-item>
					<v-tab-item value="related-service" v-if="false">
						<RelatedServiceTemplate
							v-if="inventoryTab == 'related-service'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></RelatedServiceTemplate>
					</v-tab-item>
					<v-tab-item value="work-order" v-if="false">
						<WorkOrderListing
							v-if="inventoryTab == 'work-order'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></WorkOrderListing>
					</v-tab-item>
					<v-tab-item value="file" v-if="false">
						<Files
							v-if="inventoryTab == 'file'"
							class="mx-4"
							type-text="Perishables Files"
							type="inventory"
							:type-uuid="uuid"
						></Files>
					</v-tab-item>
					<v-tab-item value="comment" v-if="false">
						<Comments
							v-if="inventoryTab == 'comment'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></Comments>
					</v-tab-item>
					<v-tab-item value="support" v-if="false">
						<SupportTemplate
							v-if="inventoryTab == 'support'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></SupportTemplate>
					</v-tab-item>
				</v-tabs-items>
			</div>
			<DeleteTemplate
				type="Perishables"
				:delete-text="deleteText"
				v-on:success="goBack()"
				v-on:close="deleteDialog = false"
				:delete-dialog="deleteDialog"
				:delete-url="deleteURL"
				:delete-note="
					!inventory.retired
						? 'To preserve associated records, you could retire the Perishables instead.'
						: null
				"
			>
				<template v-if="!inventory.retired" v-slot:extra-btn>
					<v-btn
						class="white--text"
						depressed
						color="blue darken-4"
						tile
						v-on:click="
							deleteDialog = false;
							retireDialog = true;
						"
					>
						Retire
					</v-btn>
				</template>
			</DeleteTemplate>
			<template v-if="false && retireDialog">
				<RetireTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="goBack()"
					v-on:close="retireDialog = false"
					:retire-dialog="retireDialog"
				></RetireTemplate>
			</template>
			<template v-if="false && retireStockDialog">
				<RetireStockTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="goBack()"
					v-on:close="retireStockDialog = false"
					:retire-dialog="retireStockDialog"
				></RetireStockTemplate>
			</template>
			<template v-if="false && reservationDialog">
				<ReservationTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="
						reservationDialog = false;
						getInventory();
					"
					v-on:close="reservationDialog = false"
					:reservation-dialog="reservationDialog"
				></ReservationTemplate>
			</template>
			<AddStockTemplate v-if="false" v-on:success="getInventory"></AddStockTemplate>
			<template v-if="false && checkoutDialog">
				<CheckoutTemplate
					type="Perishable"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="
						checkoutDialog = false;
						getInventory();
					"
					v-on:close="checkoutDialog = false"
					:checkout-dialog="checkoutDialog"
				></CheckoutTemplate>
			</template>
		</template>
		<template v-else>
			<div class="mx-20 my-40 text-center">
				<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
			</div>
		</template>
	</v-sheet>
</template>
<style>
.w-15 {
	width: 125px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TooltipQuestion from "@/view/components/TooltipQuestion";
import ImageTemplate from "@/view/components/Image";
import Barcode from "@/view/components/Barcode";
import Comments from "@/view/components/Comments";
import Files from "@/view/components/Files";
import QuantityLocation from "@/view/components/QuantityLocation";
import ReservationListing from "@/view/components/ReservationListing";
import TransactionListing from "@/view/components/TransactionListing";
import EventListing from "@/view/components/EventListing";
import SupplierListing from "@/view/components/SupplierListing";
import WorkOrderListing from "@/view/components/WorkOrderListing";
import { GetInventory } from "@/core/lib/inventory.lib";
import ShowValue from "@/view/components/ShowValue";
import ShowPrice from "@/view/components/ShowPrice";
import AddStockTemplate from "@/view/components/AddStockTemplate";
import { EventBus } from "@/core/event-bus/event.bus";
import DeleteTemplate from "@/view/components/DeleteTemplate";
import RetireTemplate from "@/view/components/RetireTemplate";
import RetireStockTemplate from "@/view/components/RetireStockTemplate";
import ReservationTemplate from "@/view/components/ReservationTemplate";
import RelatedServiceTemplate from "@/view/components/RelatedServiceTemplate";
import SupportTemplate from "@/view/components/SupportTemplate";
import CheckoutTemplate from "@/view/components/CheckoutTemplate";
import ItemRetirementsListing from "@/view/components/ItemRetirementsListing";
import ShowBarcode from "@/view/components/ShowBarcode";
import ProductPriceListing from "@/view/components/ProductPriceListing";
import ProductQuotationListing from "@/view/components/ProductQuotationListing";
import ProductPOMomentHistory from "@/view/components/ProductPOMomentHistory";

import { GetQuotationProductListing } from "@/core/lib/inventory.lib.js";

export default {
	name: "inventory-detail",
	title: "Detail Perishables",
	data() {
		return {
			/* inventoryTab: null, */
			uuid: null,
			barcode: null,
			deleteText: null,
			deleteURL: null,
			deleteDialog: false,
			quotationListing: null,
			checkoutDialog: false,
			quotationListingPage: 1,
			retireDialog: false,
			contentLoaded: false,
			retireStockDialog: false,
			reservationDialog: false,
			inventory: {},
			deviceWidth: document.documentElement.clientWidth,
			product: {},
		};
	},
	created() {
		window.addEventListener("resize", this.resizeEventHandler);
	},
	destroyed() {
		window.removeEventListener("resize", this.resizeEventHandler);
	},
	methods: {
		RequestPoDetail(uuid) {
			this.$router.replace({
				name: "request-po-detail",
				params: { uuid },
				query: { t: new Date().getTime() },
			});
		},

		resizeEventHandler() {
			this.deviceWidth = document.documentElement.clientWidth;
		},
		doAction(param) {
			switch (param) {
				case "edit":
					this.$router.push({
						name: "product-update",
						params: { uuid: this.uuid },
						query: { t: new Date().getTime() },
					});
					break;

				case "activestatus":
					this.$router.push({
						name: "product-update",
						params: { uuid: this.uuid },
						query: {
							t: new Date().getTime(),
							status: "approve",
						},
					});
					break;
				case "duplicate":
					this.$router.push({
						name: "inventory-create",
						query: { duplicate: this.uuid, t: new Date().getTime() },
					});
					break;
				case "delete":
					this.deleteDialog = true;
					break;
				case "retire":
					this.retireDialog = true;
					break;
				case "retire-stock":
					this.retireStockDialog = true;
					break;
				case "add-stock":
					EventBus.$emit("add:stock", { type: "inventory", typeUUID: this.uuid });
					break;
				case "stock-history":
					break;
				case "print-label":
					break;
				case "checkout-history":
					break;
				case "verification-history":
					break;
				case "reserve":
					this.reservationDialog = true;
					break;
				case "checkout":
					this.checkoutDialog = true;
					break;
			}
		},
		getInventory() {
			GetInventory(this.uuid)
				.then((data) => {
					// this.barcode = data.barcode;
					// this.inventory = data;
					// this.deleteText = `#${data.barcode} - ${data.name}`;
					// this.deleteURL = `inventory/${data.uuid}`;
					//console.log({data:data})
					(this.product = {
						barcode: data.barcode,
						type: data.product_type,
						name: data.name,
						status: data.status,
						status_value: data.status_value,
						available_stock: data.available_stock,
						serial_number: data.serial_number,
						quote_ref_no: data.quote_ref_no,
						description: data.description,
						material_standard: data.material_standard,
						dimension_standard: data.diamension_standard,
						reorder_level: data.reorder_quantity,
						unit: data.unit,
						image: data.image,
						manufacturer: data.manufacturer,
						supplier_relation: data.supplier_relation ? data.supplier_relation : [],
						pricing_logs: data.pricing_logs,
						category: data.group_relation.name,
						initial_stock: data.initial_stock,
						unit_price_currency: data.unit_price_currency,
						unit_price: data.unit_price,
						selling_cost: data.selling_cost,
						discount_price: data.discount_price,
						effective_from: data.effective_from,
						weight: data.weight,
						height: data.height,
						width: data.width,
						diameter: data.diameter,
						reduced_diameter: data.reduced_diameter,
						length: data.length,
						weight_unit: data.weight_unit,
						length_unit: data.length_unit,
						diameter_unit: data.diameter_unit,
						reduced_diameter_unit: data.reduced_diameter_unit,
						height_unit: data.height_unit,
						width_unit: data.width_unit,

						requestpobarcode: data.request_po_data,
						added_at: data.added_at,
						added_by: data.added_by,
						updated_at: data.updated_at,
						updated_by: data.updated_by,
					}),
						this.$store.dispatch(SET_BREADCRUMB, [
							{ text: "Product", disabled: true },
							{ text: "Detail", disabled: true },
							{ text: data.barcode, disabled: true },
						]);
				})
				.catch((error) => {
					this.goBack();
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
					this.contentLoaded = true;
				});
		},
		async getProductQuotation(uuid, page) {
			this.quotationListingPage = page;

			const data = await GetQuotationProductListing(uuid, this.quotationListingPage);
			this.quotationListing = data;
		},
	},
	computed: {
		inventoryTab: {
			set(val) {
				let query = { ...this.$route.query };
				query.tab = val;
				if (val != this.inventoryTab) {
					this.$router.replace({ query });
				}
			},
			get() {
				return this.$route.query.tab || "detail";
			},
		},
	},
	components: {
		Files,
		Comments,
		TooltipQuestion,
		QuantityLocation,
		ReservationListing,
		TransactionListing,
		EventListing,
		SupplierListing,
		WorkOrderListing,
		ImageTemplate,
		CheckoutTemplate,
		ShowValue,
		ShowPrice,
		ItemRetirementsListing,
		AddStockTemplate,
		DeleteTemplate,
		RetireTemplate,
		RetireStockTemplate,
		ReservationTemplate,
		RelatedServiceTemplate,
		SupportTemplate,
		Barcode,
		ShowBarcode,
		ProductPriceListing,
		ProductPOMomentHistory,
		ProductQuotationListing,
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ text: "Product", disabled: true },
			{ text: "Detail", disabled: true },
		]);

		const { uuid } = this.$route.params;
		if (uuid) {
			this.getProductQuotation(uuid, this.quotationListingPage);
		}
		this.uuid = uuid;
		if (!this.uuid) {
			this.goBack();
		}

		this.getInventory();
	},
	beforeDestroy() {
		this.$store.dispatch(SET_BREADCRUMB, []);
	},
};
</script>
